var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 12.4998C3.39009 12.4998 3.0018 12.4998 2.69552 12.373C2.28714 12.2038 1.96268 11.8794 1.79352 11.471C1.66666 11.1647 1.66666 10.7764 1.66666 9.99984V4.33317C1.66666 3.39975 1.66666 2.93304 1.84831 2.57652C2.0081 2.26292 2.26307 2.00795 2.57667 1.84816C2.93319 1.6665 3.3999 1.6665 4.33332 1.6665H9.99999C10.7766 1.6665 11.1648 1.6665 11.4711 1.79337C11.8795 1.96253 12.204 2.28698 12.3731 2.69536C12.5 3.00165 12.5 3.38993 12.5 4.1665M10.1667 18.3332H15.6667C16.6001 18.3332 17.0668 18.3332 17.4233 18.1515C17.7369 17.9917 17.9919 17.7368 18.1517 17.4232C18.3333 17.0666 18.3333 16.5999 18.3333 15.6665V10.1665C18.3333 9.23308 18.3333 8.76637 18.1517 8.40985C17.9919 8.09625 17.7369 7.84128 17.4233 7.68149C17.0668 7.49984 16.6001 7.49984 15.6667 7.49984H10.1667C9.23324 7.49984 8.76653 7.49984 8.41001 7.68149C8.0964 7.84128 7.84143 8.09625 7.68165 8.40985C7.49999 8.76637 7.49999 9.23308 7.49999 10.1665V15.6665C7.49999 16.5999 7.49999 17.0666 7.68165 17.4232C7.84143 17.7368 8.0964 17.9917 8.41001 18.1515C8.76653 18.3332 9.23324 18.3332 10.1667 18.3332Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.38daca81d8e78dd5a3ef5ea7223d61d0.svg";
export { ForwardRef as ReactComponent };